import { render, staticRenderFns } from "./PAVView.vue?vue&type=template&id=51b1982a&scoped=true"
import script from "./PAVView.vue?vue&type=script&lang=js"
export * from "./PAVView.vue?vue&type=script&lang=js"
import style0 from "./PAVView.vue?vue&type=style&index=0&id=51b1982a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51b1982a",
  null
  
)

export default component.exports